import { render, staticRenderFns } from "./tuwendaohang.vue?vue&type=template&id=3f90e65c&scoped=true&"
import script from "./tuwendaohang.vue?vue&type=script&lang=js&"
export * from "./tuwendaohang.vue?vue&type=script&lang=js&"
import style0 from "./tuwendaohang.vue?vue&type=style&index=0&id=3f90e65c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f90e65c",
  null
  
)

export default component.exports